<template>
  <div class="footer_container">
    <div class="footer_menu_container">
      <div class="menu_items">
        <div class="d-flex flex-column align-items-center"><icon icon="flights" class="mb-1" />Flight</div>
      </div>
      <div class="menu_items">
        <div class="d-flex flex-column align-items-center"><icon icon="cruise" class="mb-1" />Cruise</div>
      </div>
      <div class="menu_items">
        <div class="d-flex flex-column align-items-center"><icon class="mb-1" />Admin</div>
      </div>
      <div class="menu_items">
        <div class="d-flex flex-column align-items-center"><i class="fa fa-user fnt-16 mb-1"></i> Profile</div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/ui/icons";
export default {
  name: "Footer",
  components: { Icon }
};
</script>

<style scoped lang="scss">
.footer_container {
  display: flex;
  width: 100%;
  height: 100%;
  box-shadow: 0 -2px 0 0 var(--header-shadow-color);
  .footer_menu_container {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    .menu_items {
      display: flex;
      font-size: var(--fnt-12);
      flex: 1;
      height: 100%;
      align-items: center;
      justify-content: center;
      &:not(:last-child) {
        border-right: 1px solid var(--bs-gray-800);
      }
      svg {
        fill: var(--white);
        height: 18px;
      }
    }
  }
}
</style>